<template>
    <div class="course_content use_common" :class="{ course_content_bottom: !isBeginActivity, course_content_bottom_iphoneX: isIphoneX}">
        <!--活动已结束-->
        <div v-if="!isEndActivity" v-cloak>
            <div v-if="activityInfo.bannerUrl">
                <img class="course_bg" :src="activityInfo.bannerUrl" alt="">
                <div class="title_radius"></div>
            </div>
            <div class="banner_height" v-else></div>
            <!--标题栏内容-->
            <div class="title_content" v-if="navNumberList.length > 0">
                <div class="school_title_content flex_box" @click="selectSchoolType(1)" v-if="navNumberList.indexOf(0) > -1">
                    <img class="school_icon" src="../../assets/schoolicon.png" alt="">
                    <div class="school_title tow">
                        校区：{{schoolName || '请选择'}}
                    </div>
                    <img class="down_arrow_icon" src="../../assets/downarrow.png" alt="">
                </div>
                <div class="school_title_content flex_box" @click="selectSchoolType(2)" v-if="navNumberList.indexOf(1) > -1">
                    <img class="school_icon" src="../../assets/schoolclassicon.png" alt="">
                    <div class="school_title tow">
                        年级：{{gradeName || '请选择'}}
                    </div>
                    <img class="down_arrow_icon" src="../../assets/downarrow.png" alt="">
                </div>
                <div class="subject_content" v-if="navNumberList.indexOf(2) > -1">
                    <div class="subject_icon_content subject_icon_content_bottom flex_box">
                        <img class="subject_icon" src="../../assets/subjecticon.png" alt="">
                        <div class="subject_title">选择科目</div>
                    </div>
                    <div class="subject_line"></div>
                    <div class="subject_type_content flex_box">
                        <span class="subject_name tow" v-for="(subject, index) in subjectList" :class="{subject_name_color: (selectSubjectId !== '' && Number(selectSubjectId) === index)}" :key="index" @click="selectSubject(subject, index)">{{subject}}</span>
                    </div>
                </div>
                <div class="school_title_content flex_box" @click="selectSchoolType(3)" v-if="navNumberList.indexOf(3) > -1 && selectNavString == navNumberShowString">
                    <img class="school_icon" src="../../assets/schooltimeicon.png" alt="">
                    <div class="school_title tow">
                        时间：{{timeName || '请选择'}}
                    </div>
                    <img class="down_arrow_icon" src="../../assets/downarrow.png" alt="">
                </div>
            </div>
            <!--课程内容-->
            <div class="new_course_package_list add_style" v-cloak>
                <div class="package_content" v-if="courseList">
                    <div class="package_title flex_box package_title_style">
                        <div class="package_title_color"></div>
                        <div class="package_title_text tow">选课</div>
                    </div>
                    <div class="course_list_details detail_style" v-for="(courseItem, courseIndex) in courseList" :key="courseIndex"  @click="selectCourse(courseItem)">
                        <div class="course_name_content">
                            <span class="teaching_methods" v-if="courseItem.teachingMethod">{{courseItem.teachingMethod}}</span>
                            <span class="course_name">{{courseItem.productName}}</span>
                        </div>

                        <div class="flex_box course_details" v-if="courseItem.lessonNumMin">
                            <img class="card_time_icon" src="../../assets/cardtimeicon.png" />
                            <span class="class_num tow">{{courseItem.lessonNumMin == courseItem.lessonNumMax ? courseItem.lessonNumMin : (courseItem.lessonNumMin + '-' + courseItem.lessonNumMax)}}课时</span>
                        </div>
                        <div class="flex_box course_details">
                            <img class="card_year_icon" src="../../assets/cardyearicon.png" />
                            <span class="class_num">根据学员的个性化需求灵活排课</span>
                        </div>

                        <div class="course_dot_line"></div>

                        <div class="flex_box lesson_and_price_content">
                            <div class="flex_box_column">
                                <div class="flex_box more_teacher_content">
                                    <img class="teacher_icon" src="../../assets/teacher_01.png" />
                                    <img class="teacher_icon" src="../../assets/teacher_02.png" />
                                    <img class="teacher_icon" src="../../assets/teacher_03.png" />
                                </div>
                                <div class="teacher_group">新东方教学团队</div>
                            </div>
                            <div class="price_symbol_content">
                                <span class="price_symbol">¥</span>
                                <span class="course_price">{{courseItem.priceMin == courseItem.priceMax ? courseItem.priceMin : (courseItem.priceMin + '-' + courseItem.priceMax)}}</span>
                                <span class="price_symbol" v-if="courseItem.priceMethodType == 2">/课时</span>
                            </div>
                        </div>
                        <div class="select_icon">
                            <img v-if="courseItem.isSelect" src="../../assets/selectcourse.png" alt="">
                            <img v-else src="../../assets/unselectcourse.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <!--课程图片内容-->
            <div class="course_img" v-if="activityInfo.detailUrl">
                <img :src="activityInfo.detailUrl" alt="">
            </div>
            <!--底部按钮-->
            <div v-if="!isInIframe">
                <div class="activity_time" v-if="!isBeginActivity" :class="{activity_time_bottom: isIphoneX}">
                    活动将于{{beginTimeText}}开始
                </div>
                <div class="new_footer flex_box" :class="{footer_content_bottom: isIphoneX}">
                    <div class="flex_box" v-if="marketOninfo.isShowReservationEntrance == 1">
                        <div class="appointment_audition" @click="openReservationUrl">预约试听</div>
                        <div class="sign_up" :class="{sign_up_width_no: !highProductId}" @click="payMoney">立即报名{{highProductId ? '(1)' : ''}}</div>
                    </div>
                    <div class="sign_up_width" @click="payMoney" :class="{sign_up_width_no: !highProductId}" v-else>立即报名{{highProductId ? '(1)' : ''}}</div>
                </div>
            </div>
        </div>

        <!--活动已结束-->
        <div v-if="isEndActivity">
            <end-activity></end-activity>
        </div>

        <!--弹窗内容-->
        <div class="school_list_bg" v-if="isShowPopupList">
            <div class="school_content">
                <div class="school_title_content flex_box">
                    <span class="school_title">{{popupTitle}}</span>
                    <img class="close_icon" src="../../assets/closeicon.png" alt="" @click="closePopupList">
                </div>

                <div class="school_list">
                    <div class="school_list_info" v-for="(item, index) in filterTypeList" :key="index" @click="selectFilterItem(item, index)">
                        <div class="school_name tow" :class="{school_name_color: (selectTypeId !== '' && Number(selectTypeId) === index)}">{{item}}</div>
                        <div class="dot_line"></div>
                    </div>
                </div>
            </div>
        </div>
        <studentPopuper
            v-if="ispopshow"
            :show="ispopshow"
            :list="studentList"
            :showTitleType="true"
            @closepop="closepop"
            @checkedCode="checkedCode"
        />
    </div>
</template>

<script>
    import wxSdk from '../../libs/wxsdk.js'
    import EndActivity from '../../components/endActivity'
    import studentPopuper from '../../components/studentPopuper'
    import {
        getNewMarketInfo, getHighEndClassList, recordChannel, getMarketDimension, checkWxLogin,
        getStudentList, getGan
    } from '../../libs/api'
    import {
        formatDateUtil,
        getIphoneXType,
        isWeChat,
        getUrlParam
    } from "../../libs/util"
    import configData from '../../libs/conf'
    import { Indicator, Toast} from 'mint-ui'
    import Cookies from 'js-cookie'
    export default {
        name: "newsinglecourse",
        metaInfo () {
            return {
                title: this.pageName
            }
        },
        components: {
            'end-activity': EndActivity,
            studentPopuper
        },
        data() {
            return {
                phone: '',
                pageName: '新东方专题活动',
                isFixedHeight: false, // 是否固定页面高度
                isShowPopupList:false, // 是否显示弹窗列表
                popupTitle:'', // 弹窗标题
                subjectList: [], // 科目列表
                navList: [], // 导航栏
                filterTypeList: [], // 筛选列表
                selectTypeId: '', // 选中筛选类型的Id
                filterNum: '', // 1: 学校 2: 年级  3: 时间
                schoolName: '', // 校区名字
                gradeName: '', // 年级名字
                subjectName: '', // 科目名字
                timeName: '', // 时间名字
                selectSchoolId: '', // 选中的学校Id
                selectGradeId: '', // 选中的校区Id
                selectSubjectId: '', // 选中的科目Id
                selectTimeId: '', // 选中的时间Id
                navNumberList:[], // 导航栏的存在的数字
                navNumberShowString: '', // 导航栏的存在先显示的数字
                selectNavString: '', // 选择学校0，时间1，科目2，显示时间栏
                activityInfo: '', // 活动信息
                beginTimeText: '', // 活动开始时间
                isBeginActivity: true, // 是否开始活动
                isEndActivity: false, // 是否结束活动
                courseList:[], // 课程列表
                activityId: '', // 活动Id
                U2AT:'', // token
                schoolId: '', // 学校Id
                isIosApp: false, // 是否是iosApp
                isIphoneX: false, // 是否iphoneX
                isLoadFull: false, // 是否加载完
                isWeChat: false, //  是否在微信环境内
                wxNickName: '', // 打点微信数据
                studentCode: '',
                studentName: '', // 加购学员姓名
                studentPhone: '', // 加购学员手机号
                ispopshow: false,
                studentList: [],
                highEndClassCode: '',  // 选择的高端课程的code
                marketOninfo: '',  // 高端信息
                highProductId: '',  // 高端产品Id
                oneDistributionEmail: '', // 邮箱
                agn: '', // 推广渠道
                isInIframe: false  // 暂时只在推广中心使用
            }
        },
        created () {
            let hostname = top.location.hostname
            if (hostname == configData.promotion || hostname == configData.promotionTestOne || hostname == configData.promotionTestTwo || hostname == configData.promotionTestThree) {
                this.isInIframe = true
            }
        },
        mounted () {
            // 专题详情
            Indicator.open({
                text: '加载中...',
                spinnerType: 'fading-circle'
            })
            let queryParams = this.$route.query
            if (queryParams.pageValue) {
                queryParams = getUrlParam(queryParams.pageValue)
            }
            console.log('参数', queryParams)
            // 获取标题参数
            let highEndCourseTitle = JSON.parse(sessionStorage.getItem('highEndCourseTitle'))
            if (!highEndCourseTitle  || (highEndCourseTitle && queryParams && highEndCourseTitle.activityId != queryParams.activityId)) {
                sessionStorage.clear()
                highEndCourseTitle = queryParams
            }
            if (highEndCourseTitle) {
                this.schoolName = highEndCourseTitle.schoolName || ''
                this.selectSchoolId = highEndCourseTitle.selectSchoolId || ''
                this.gradeName = highEndCourseTitle.gradeName || ''
                this.selectGradeId  = highEndCourseTitle.selectGradeId || ''
                this.subjectName = highEndCourseTitle.subjectName || ''
                this.selectSubjectId = highEndCourseTitle.selectSubjectId || ''
                this.timeName  = highEndCourseTitle.timeName || ''
                this.selectTimeId  = highEndCourseTitle.selectTimeId || ''
                this.filterNum = Number(highEndCourseTitle.filterNum) || ''
                this.activityId = highEndCourseTitle.activityId || ''
                this.channelId = highEndCourseTitle.channelId || ''
                this.agn = highEndCourseTitle.agn || ''
                this.selectNavString = highEndCourseTitle.selectNavString || ''
                if (highEndCourseTitle.selectSchoolId === 0) {
                    this.selectSchoolId = 0
                }
                if (highEndCourseTitle.selectGradeId === 0) {
                    this.selectGradeId = 0
                }

                if (highEndCourseTitle.selectSubjectId === 0) {
                    this.selectSubjectId = 0
                }
                if (highEndCourseTitle.selectTimeId === 0) {
                    this.selectTimeId = 0
                }
                this.saveTitleInfo()
                switch(Number(this.filterNum)) {
                    case 1: // 校区名字
                        this.selectTypeId = this.selectSchoolId
                        break
                    case 2: // 年级名字

                        this.selectTypeId = this.selectGradeId
                        break
                    case 3: // 时间名字
                        this.selectTypeId = this.selectTimeId
                        break
                    case 4: // 科目名字
                        this.selectTypeId = this.selectSubjectId
                        break
                }
            }
            // 判断是否在微信环境内,是否授权
            this.isWeChat = isWeChat()

            // 获取纬度及课程列表
            this.getMarketInfo()
            this.getMarketClassList()
            this.getGan()

            // 打点数据
            gio('page.set',{
                'activity_id': this.activityId,
                'channel_id': this.channelId
            })

            // 是否在app内并且是否是ios
            if (xdfJs.xdfhybird.inApp && !xdfJs.xdfhybird.android) {
                this.isIosApp = true
            }

            // 判断是否IphoneX
            this.isIphoneX = getIphoneXType()
            // 后退刷新页面
            window.addEventListener('pageshow', (e) => {
                if (
                    e.persisted ||
                    (window.performance && window.performance.navigation.type == 2)
                ) {
                    window.location.reload()
                }
            }, false)
        },
        methods: {
            checkedCode (data) {
                this.studentCode = data.studentCodes[0].studentCode
                this.studentName = data.realName
                this.studentPhone = data.mobile
                this.ispopshow = false
                let channelCode = this.agn || this.channelId
                let params = `productId=${this.highProductId}&systemSource=yxzt&appId=yxzt&studentCode=${this.studentCode}` +
                    `&optEmail=${this.oneDistributionEmail}&schoolId=${this.schoolId}&channalCode=${channelCode}&activityCode=${this.activityInfo.uniActivityId}`
                window.parent.location.href = `${configData.highEndDomain}/order/u2/add-market?${params}`
            },
            closepop () {
                this.ispopshow = false
            },
            // 选择筛选选项
            selectSchoolType(num) {
                document.documentElement.style.overflow = "hidden"
                this.filterNum = num
                this.selectTypeId = ''
                this.isShowPopupList = true
                switch(num) {
                    case 1: // 校区名字
                        this.selectTypeId = this.selectSchoolId
                        this.popupTitle = '校区'
                        this.getMarketDimension(1, 2)
                        break
                    case 2: // 年级名字
                        this.selectTypeId = this.selectGradeId
                        this.popupTitle = '年级'
                        this.getMarketDimension(2, 2)
                        break
                    case 3: // 时间名字
                        this.selectTypeId = this.selectTimeId
                        this.popupTitle = '时间'
                        this.getMarketDimension(3, 2)
                        break
                }
            },
            // 选择筛选列表
            selectFilterItem(itemName, itemIndex) {
                Indicator.open({
                    text: '加载中...',
                    spinnerType: 'fading-circle'
                })
                document.documentElement.style.overflow = "scroll"
                this.isShowPopupList = false
                this.selectTypeId = itemIndex
                switch(this.filterNum) {
                    case 1: // 校区名字
                        this.selectSchoolId = itemIndex
                        this.schoolName = itemName
                        this.selectNavString = ''
                        if (this.selectNavString.indexOf('0') == -1) {
                            this.selectNavString += '0'
                        }
                        // 重新选择清空数据
                        this.selectGradeId = ''
                        this.gradeName = ''
                        this.selectSubjectId = ''
                        this.subjectName = ''
                        this.selectTimeId = ''
                        this.timeName = ''
                        break
                    case 2: // 年级名字
                        this.selectGradeId = itemIndex
                        this.gradeName = itemName
                        if (this.selectNavString.indexOf('0') > -1) {
                            this.selectNavString = '0'
                        } else {
                            this.selectNavString = ''
                        }
                        if (this.selectNavString.indexOf('1') == -1) {
                            this.selectNavString += '1'
                        }
                        // 重新选择清空数据
                        this.selectSubjectId = ''
                        this.subjectName = ''
                        this.selectTimeId = ''
                        this.timeName = ''
                        break
                    case 3: // 时间名字
                        this.selectTimeId = itemIndex
                        this.timeName = itemName
                        break
                }
                this.saveTitleInfo()
                this.courseList = []
                this.getMarketClassList()
                if (this.filterNum === 1 || this.filterNum === 2) {
                    this.getMarketDimension(4, 1)
                }
                this.getWxSdk()
            },
            // 选择科目
            selectSubject(subjectName, subjectIndex) {
                this.filterNum = 4
                this.subjectName = subjectName
                this.selectSubjectId = subjectIndex
                // 重新选择清空数据
                this.selectTimeId = ''
                this.timeName = ''
                if (this.selectNavString.indexOf('2') == -1) {
                    this.selectNavString += '2'
                }
                this.saveTitleInfo()
                this.courseList = []
                this.getMarketClassList()
                this.getWxSdk()
            },
            // 存储标题参数
            saveTitleInfo () {
                // 存储学校名字
                let highEndCourseTitleInfo = {
                    schoolName: this.schoolName,
                    selectSchoolId: this.selectSchoolId,
                    gradeName: this.gradeName,
                    selectGradeId: this.selectGradeId,
                    subjectName: this.subjectName,
                    selectSubjectId: this.selectSubjectId,
                    timeName: this.timeName,
                    selectTimeId: this.selectTimeId,
                    filterNum: this.filterNum,
                    activityId: this.activityId,
                    channelId: this.channelId,
                    selectNavString: this.selectNavString,
                    agn: this.agn
                }
                sessionStorage.setItem('highEndCourseTitle', JSON.stringify(highEndCourseTitleInfo))
                if (this.isInIframe) {
                    let iframeUrl = this.getHttpUrl()
                    window.location.replace(iframeUrl)
                }
            },
            // 关闭弹窗
            closePopupList() {
                document.documentElement.style.overflow = "scroll"
                this.isShowPopupList = false
            },
            // 获取专题详情
            getMarketInfo(){
                getNewMarketInfo(this.activityId).then((res) => {
                    let resData = res
                    if (resData.code == 1) {
                        let data = resData.data
                        this.activityInfo = data.activityinfo
                        this.marketOninfo = data.marketOninfo
                        let nowTime = new Date(this.activityInfo.nowTime.replace(/-/g, '/') + '+0800').valueOf()
                        let beginTime = new Date(this.activityInfo.beginTime.replace(/-/g, '/') + '+0800').valueOf()
                        let beginTimeText = formatDateUtil(new Date(this.activityInfo.beginTime.replace(/-/g, '/') + '+0800'), 'MM月dd日 HH:mm')
                        let endTime = new Date(this.activityInfo.endTime.replace(/-/g, '/') + '+0800').valueOf()
                        this.beginTimeText = beginTimeText
                        this.phone = this.activityInfo.connectPhone || ''
                        this.schoolId = this.activityInfo.schoolId
                        this.pageName = this.activityInfo.title

                        this.checkWxLogin()

                        // 活动未开始
                        if (nowTime < beginTime) {
                            this.isBeginActivity = false
                        }
                        // 活动已结束
                        if (nowTime > endTime) {
                            this.isEndActivity = true
                        }

                        // 科目在选择校区及年级后重新赋值
                        this.subjectList = data.subjectSet

                        // 标题列表
                        this.navList = data.navList
                        this.navList.forEach((navItem) => {
                            this.navNumberList.push(navItem.type)
                            if (navItem.type < 3) {
                                this.navNumberShowString += navItem.type
                            }
                        })

                        if (this.schoolName || this.gradeName || this.subjectName || this.classTime) {
                            // 在初始化，不要使用filterNum为3，否则科目会被初始化
                            if (this.filterNum = 3 && this.subjectName) {
                                this.filterNum = 4
                            }
                            this.getMarketDimension(this.filterNum, 1)
                        }
                        // 微信分享
                        this.getWxSdk()
                    }
                })
            },
            // 获取营销纬度
            getMarketDimension(num, secondNum) {
                // alert(num)
                let data = {
                    activityId: this.activityId,
                    campusName: this.schoolName,
                    gradeName: this.gradeName,
                    subjectName: this.subjectName,
                    classTime: ''
                }
                // 获取全部学校
                if (num === 1) {
                    data = {
                        activityId: this.activityId,
                        campusName: '',
                        gradeName: '',
                        subjectName:'',
                        classTime: ''
                    }
                }
                // 获取全部年级
                if (num === 2) {
                    data = {
                        activityId: this.activityId,
                        campusName: this.schoolName,
                        gradeName: '',
                        subjectName:'',
                        classTime: ''
                    }
                }
                // 获取全部时间
                if (num === 4) {
                    data = {
                        activityId: this.activityId,
                        campusName: this.schoolName,
                        gradeName: this.gradeName,
                        subjectName: '',
                        classTime: ''
                    }
                }
                getMarketDimension(data).then((res) => {
                    if (secondNum != 1) {
                        this.isFixedHeight = true
                        this.isShowPopupList = true
                    }
                    if (res.code == 1) {
                        let resData = res.data
                        if (num === 1) {
                            this.filterTypeList = resData.campusNameSet
                        } else if (num === 2) {
                            this.filterTypeList = resData.gradeNameSet
                        } else {
                            this.filterTypeList = resData.classTimeSet
                        }
                        // 3是时间，不要影响科目的显示
                        if (secondNum != 2 && num !== 3) {
                            this.subjectList = resData.subjectNameSet
                        }
                    }
                })
            },
            // 获取班级列表
            getMarketClassList() {
                let data = {
                    campusName: this.schoolName,
                    gradeName: this.gradeName,
                    classTime: this.timeName,
                    subjectName: this.subjectName,
                    activityId: this.activityId
                }
                getHighEndClassList(data).then((res) => {
                    Indicator.close()
                    if (res.code == 1 && res.data) {
                        let courseData = res.data
                        console.log('课程列表', courseData)
                        //课程列表
                        if (courseData) {
                            courseData.forEach((classItem, index) => {
                                // 默认选择第一个
                                if (index == 0) {
                                    classItem.isSelect = true
                                    this.highProductId = classItem.productId
                                } else {
                                    classItem.isSelect = false
                                }
                            })
                        }
                        this.courseList = courseData
                    }
                })
            },
            // 单个课程
            selectCourse (course) {
                if (course.isSelect) {
                    return
                }
                course.isSelect = true
                this.highProductId = course.productId
                this.courseList.forEach((classItem) => {
                    if (classItem.productId === course.productId) {
                        classItem.isSelect = true
                    } else {
                        classItem.isSelect = false
                    }
                })
            },
            // 打开预约链接
            openReservationUrl() {
                window.parent.location.href = this.marketOninfo.reservationUrl
            },
            // 记录渠道
            recordChannel() {
                let data = {
                    channelId: this.channelId,
                    u2at: this.U2AT,
                    wxNickname: this.wxNickName || '',
                    agn: this.agn || ''
                }
                recordChannel(data).then((res) => {
                    let reaData = res

                    if (reaData.code == 1 && reaData.data && reaData.data.userid) {
                        sessionStorage.setItem('userId', reaData.data.userid)
                        gio('setUserId', reaData.data.userid)
                    }
                })
            },
            // 记录渠道
            checkWxLogin(num) {
                checkWxLogin().then((res) => {
                    let reaData = res
                    let url = this.getHttpUrl()
                    // 微信授权
                    if (reaData.code == 4002 && this.isWeChat && !this.isInIframe) {
                        let wxLogin = configData.wxlogin
                        window.parent.location.href = wxLogin + '&returnUrl=' + encodeURIComponent(url)
                    }

                    if (reaData.code == 200) {
                        this.getStudent()
                        if(reaData.data && reaData.data.wxNickName) {
                            this.wxNickName = reaData.data.wxNickName
                        }
                    }

                    // 测试数据 记录渠道
                    if (!num) {
                        this.U2AT = Cookies.get('U2AT')
                        let userId = sessionStorage.getItem('userId')
                        if (this.U2AT && !userId) {
                            this.recordChannel()
                        }
                    }

                    // 登录过期
                    if (num === 1) {
                        if (reaData.code == 4000) {
                            let urlLogin = configData.h5Login
                            window.parent.location.href = urlLogin + '&redirect_uri=' + encodeURIComponent(url)
                        } else {
                            // 放在选择的学员列表的时候去做
                            if (this.studentList.length <= 1) {
                                let channelCode = this.agn || this.channelId
                                let params = `productId=${this.highProductId}&systemSource=yxzt&appId=yxzt&studentCode=${this.studentCode}` +
                                    `&optEmail=${this.oneDistributionEmail}&schoolId=${this.schoolId}&channalCode=${channelCode}&activityCode=${this.activityInfo.uniActivityId}`
                                window.parent.location.href = `${configData.highEndDomain}/order/u2/add-market?${params}`
                            } else {
                                this.ispopshow = true
                            }
                        }
                    }
                })
            },
            getStudent () {
                getStudentList({
                    schoolId: this.schoolId,
                }).then((res) => {
                    if (res.code == '200') {
                        console.log('学员信息', res.data)
                        let data = res.data
                        if (data.length === 1) {
                            this.studentCode = data[0].studentCodes[0].studentCode
                            this.studentName = data[0].realName
                            this.studentPhone = data[0].mobile
                        } else {
                            this.studentList = data || ''
                        }
                    }
                })
            },
            payMoney() {
                if (!this.highProductId) {
                    return;
                }

                if (!this.isBeginActivity) {
                    Toast({
                        message: '当前活动还未开始哦~',
                        duration: 2000,
                        className: 'noticeError'
                    })
                    return
                }

                // 在app中去登陆
                if (xdfJs.xdfhybird.inApp) {
                    this.getAppToken()
                    return
                }

                if (this.U2AT) {
                    // 已登陆
                    this.checkWxLogin(1)
                } else {
                    // 未登录  因为需要加学员，要跳回原页面
                    let url = this.getHttpUrl()
                    window.parent.location.href = configData.h5Login + '&redirect_uri=' + encodeURIComponent(url)
                }
            },
            // 获取app的token
            getAppToken() {
                xdfJs.xdfhybird.getUser( (data) => {
                    // 判断用户是否登陆
                    if (
                        data &&
                        data.user &&
                        !!data.user.userId &&
                        data.user.userId.length > 0
                    ) {
                        let token = data["user"]["accessToken"]
                        this.U2AT = token
                        Cookies.set('U2AT', token, { expires: 30, domain: 'xdf.cn' })
                        this.recordChannel()
                        // 跳转到支付
                        let channelCode = this.agn || this.channelId
                        let params = `productId=${this.highProductId}&systemSource=yxzt&appId=yxzt&studentCode=${this.studentCode}` +
                            `&optEmail=${this.oneDistributionEmail}&schoolId=${this.schoolId}&channalCode=${channelCode}&activityCode=${this.activityInfo.uniActivityId}`
                        let url = `${configData.highEndDomain}/order/u2/add-market?${params}`

                        if (token) {
                            xdfJs.xdfhybird.openURL("xdfapp://student/web", {"url": url})
                        }
                    } else {
                        xdfJs.xdfhybird.openURL("xdfapp://student/login", {})
                    }
                })
            },
            // 微信分享
            getWxSdk() {
                let shareObj = {
                    urlLogo: this.activityInfo.shareUrl || '',// 分享图标
                    desc: this.activityInfo.shareDesc || ''
                }
                shareObj.title = this.activityInfo.shareTitle || this.activityInfo.title
                let params = this.getParams()
                shareObj.link = configData.originUrl + 'highend/course?pageValue=' + encodeURIComponent(params)
                wxSdk.getWxSdk(shareObj)
            },
            getParams() {
                let params = `activityId=${this.activityId}&channelId=${this.channelId}&schoolName=${this.schoolName}&gradeName=${this.gradeName}&timeName=${this.timeName}&subjectName=${this.subjectName}` +
                    `&selectSchoolId=${this.selectSchoolId}&selectGradeId=${this.selectGradeId}&selectTimeId=${this.selectTimeId}&selectSubjectId=${this.selectSubjectId}&selectNavString=${this.selectNavString}&filterNum=${this.filterNum}&agn=${this.agn}`
                return params
            },
            // 获取分享链接
            getHttpUrl() {
                let httpUrl = configData.originUrl + 'highend/course?'
                let params = this.getParams()
                let url =  httpUrl + params
                return url
            },
            getGan() {
                // 专题详情
                let data = {
                    activityId: this.activityId,
                    agn: this.agn
                }
                getGan(data).then((res) => {
                    let resData = res
                    if (resData.code == 1) {
                        this.oneDistributionEmail = resData.data.agentName
                    }
                })
            },
        }
    }
</script>

<style lang="less" scoped>
    .course_content {
        padding-bottom:100px;
        .course_bg {
            width: 100%;
        }
        .title_radius {
            position: relative;
            width:100%;
            height:44px;
            background: #fff;
            border-radius:20px 20px 0px 0px;
            margin-top: -20px;
            margin-bottom: 12px;
        }

        .banner_height {
            width: 100%;
            height: 32px;
        }
        /*标题栏内容*/
        .title_content {
            margin-bottom: 80px;
            .school_title_content {
                width:670px;
                height:96px;
                background:rgba(255,255,255,1);
                box-shadow:0px 4px 20px 0px rgba(206,223,241,0.3);
                border-radius:32px;
                margin: 0 auto 32px;
                padding-left: 8px;
                padding-right: 40px;
                position: relative;
                overflow: hidden;
                border:1px solid rgba(237,240,247,0.7);
                .school_icon {
                    width: 68px;
                    height: 68px;
                }
                .school_title {
                    width:514px;
                    font-size:30px;
                    color:rgba(51,51,51,1);
                    line-height:40px;
                    font-weight: 400;
                }
                .down_arrow_icon {
                    width: 18px;
                    height: 12px;
                    margin-left: auto;
                }
            }
            /*.school_title_content:after {*/
            /*    content: ".";*/
            /*    color: transparent;*/
            /*    width: 200%;*/
            /*    height: 200%;*/
            /*    border: 1px solid rgba(237,240,247,0.7);*/
            /*    border-radius:20px;*/
            /*    transform-origin: 0 0;*/
            /*    transform: scale(.5,.5);*/
            /*    position: absolute;*/
            /*    left: 0;*/
            /*    top: 0;*/
            /*}*/
            .subject_content {
                width:670px;
                min-height:162px;
                background:rgba(255,255,255,1);
                box-shadow:0px 4px 20px 0px rgba(206,223,241,0.3);
                border-radius:32px;
                border:1px solid rgba(237,240,247,0.7);
                margin: 0 auto 32px;
                padding-top: 14px;
                padding-left: 8px;
                padding-bottom: 4px;
                overflow: hidden;
                .subject_icon_content {
                    .subject_icon {
                        width: 68px;
                        height: 68px;
                    }
                    .subject_title {
                        font-size:30px;
                        color:rgba(51,51,51,1);
                        line-height:40px;
                    }
                }
                .subject_icon_content {
                    margin-bottom: 14px;
                }
                .subject_line {
                    width:622px;
                    height: 1px;
                    background:rgba(227,227,227,1);
                    margin-left: 14px;
                    margin-bottom: 30px;
                    transform: scale(1,.5);
                }
                .subject_type_content {
                    flex-wrap: wrap;
                    padding-left: 16px;
                    .subject_name {
                        width:144px;
                        height:72px;
                        background:rgba(243,243,243,1);
                        border-radius:40px;
                        opacity:0.8;
                        font-size:28px;
                        color:rgba(136,136,136,1);
                        line-height:72px;
                        text-align: center;
                        margin-right: 16px;
                        margin-bottom: 24px;
                    }
                    .subject_name_color {
                        background:linear-gradient(90deg,rgba(255,162,70,1) 0%,rgba(255,135,15,1) 100%);
                        box-shadow:0px 4px 14px 0px rgba(255,127,0,0.5);
                        color: #fff;
                        opacity: 1;
                    }
                }
            }
        }
        /*查看全部课程*/
        .check_all_course {
            justify-content: center;
            margin-top: 56px;
            margin-bottom: 60px;
            .all_course_title {
                font-size:24px;
                color:rgba(252,148,53,1);
                line-height:34px;
                margin-right: 20px;
            }
            .course_left_arrow {
                width: 10px;
                height: 18px;
            }
        }
        /*课程图片内容*/
        .course_img {
            margin-top: 60px;
            width: 100%;
            img {
                display: block;
                width: 100%;
            }
        }

        /*学校列表*/
        .school_list_bg {
            position: fixed;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            z-index: 1001;
            background:rgba(0,0,0,0.7);
            .school_content {
                position: absolute;
                left: 0;
                bottom: 0;
                right: 0;
                margin: auto;
                width:750px;
                background: #fff;
                border-radius:20px 20px 0px 0px;
                overflow: auto;
                padding: 42px 32px 0;
                .school_title_content {
                    justify-content: space-between;
                    margin-bottom: 30px;
                    .school_title {
                        font-size:40px;
                        font-weight:bold;
                        color:rgba(30,30,30,1);
                        line-height:56px;
                    }
                    .close_icon {
                        width: 32px;
                        height: 32px;
                        margin-top: -16px;
                    }
                }
                .school_list {
                    max-height: 800px;
                    min-height: 660px;
                    overflow-y: scroll;
                    .school_list_info {
                        .school_name {
                            font-size:30px;
                            color:rgba(30,30,30,1);
                            line-height:42px;

                        }
                        .school_name_color {
                            color: #1FB895;
                        }
                        .dot_line {
                            width:686px;
                            height: .5px;
                            background:rgba(227,227,227,1);
                            border-radius:10px;
                            transform: scale(1,.5);
                            margin: 28px auto 30px;
                        }
                    }
                }
            }
        }
    }
    .course_content_bottom {
        padding-bottom:170px;
    }
    .course_content_bottom_iphoneX {
        padding-bottom:168px;
    }
    .package_title_style {
        margin-bottom: 48px !important;
    }
    .detail_style {
        margin-top: 0 !important;
        margin-bottom: 40px !important;
    }
    .add_style {
        margin-top: 8px;
    }
    .select_all {
        width: 170px !important;
    }
    .new_footer {
        position: fixed;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100px;
        padding-left: 50px;
        padding-right: 12px;
        background: #fff;
        justify-content: space-between;
        box-shadow: 0px 6px 20px 0px rgba(206, 223, 241, 0.7);
        font-size: 32px;
        color: #FFFFFF;
        line-height: 80px;
        text-align: center;
        .appointment_audition {
            width: 200px;
            height: 80px;
            background: linear-gradient(330deg, #FF960F 0%, #FFC246 100%);
            border-radius: 200px;
        }

        .sign_up {
            width: 400px;
            height: 80px;
            background: linear-gradient(90deg, #FF5F28 0%, #FF692B 100%);
            border-radius: 200px;
            text-align: center;
            margin-left: 52px;
        }
        .sign_up_width {
            width: 652px;
            height: 80px;
            background: linear-gradient(90deg, #FF5F28 0%, #FF692B 100%);
            border-radius: 200px;
        }

        .sign_up_width_no {
            background: #F3F3F3;
            color: #BBBBBB;
        }
    }
    .footer_content_bottom {
        height: 146px;
        padding-bottom: 46px;
    }
    .cart-error-mask {
        width: 100%;
        height: 100vh;
        background: rgba(0, 0, 0, .7);
        position: fixed;
        z-index: 98;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .cart-error-text {
        width: 590px;
        // max-height: 66vh;
        background: #fff;
        border-radius: 20px;
        font-size: 28px;
        // position: fixed;
        // top: 50%;
        // left: 50%;
        // transform: translate(-50%, -60%);
        z-index: 98;
        h3 {
            font-size: 40px;
            line-height: 56px;
            margin: 0;
            padding: 44px 0 24px 0;
            text-align: center;
        }
        .cart-error-wrap {
            line-height: 48px;
            padding: 0 36px 0 30px;
            color: #1e1e1e;
            overflow-y: scroll;
            max-height: 50vh;
            font-weight: 300;
            /deep/ div {
                padding-left: 36px;
                background: url('../../assets/warning.svg')  no-repeat 0 8px;
                background-size: 28px 28px;
            }
            /deep/ hr {
                border: 0;
                height: 1px;
                margin: 30px 0;
                background: #e3e3e3;
            }
        }
        .handle-cart-error-text {
            height: 90px;
            line-height: 90px;
            margin-top: 34px;
            border-top: 1px solid #e3e3e3;
            font-size: 32px;
            color: #1fb895;
            text-align: center;
        }
    }

    /*课程内容*/
    .new_course_package_list {
        padding: 0 32px;
        .package_title {
            position: relative;
            .package_title_text {
                width:538px;
                font-size:40px;
                font-weight:500;
                color:rgba(51,51,51,1);
                line-height:56px;
            }
            .package_title_color {
                position: absolute;
                left: -32px;
                width: 8px;
                height: 40px;
                background: #FF870F;
                border-radius: 0px 6px 6px 0px;
            }
        }
        .package_content {
            .course_list_details {
                position: relative;
                margin: 30px auto 0;
                width:670px;
                background:rgba(255,255,255,1);
                box-shadow:0px 6px 30px 0px rgba(206,223,241,0.4);
                border-radius: 32px;
                padding: 40px;
                border: 1px solid rgba(237,240,247,0.7);
                .course_name_content {
                    display: inline-block;
                    margin-bottom: 18px;
                    width: 510px;
                    .teaching_methods {
                        display: inline-block;
                        border-radius:6px;
                        font-size:24px;
                        line-height: 24px;
                        font-weight: normal;
                        color:rgba(31,184,149,1);
                        text-align: center;
                        margin-right: 12px;
                        position: relative;
                        top: -2px;
                        padding: 6px 6px 4px;
                        background: #fff;
                    }

                    .teaching_methods:after {
                        content: ".";
                        color: transparent;
                        width: 200%;
                        height: 200%;
                        border: .5px solid rgba(64,210,157,1);
                        border-radius: 16px;
                        transform-origin: 0 0;
                        transform: scale(.5,.5);
                        position: absolute;
                        left: 0;
                        top: 0;
                    }

                    .course_name {
                        font-size:34px;
                        font-weight: normal;
                        color:rgba(30,30,30,1);
                        line-height:48px;
                        position: relative;
                        top: 2px;
                    }
                }

                .course_details {
                    margin-bottom: 18px;
                    .copy_class_num_icon {
                        width: 30px;
                        height: 30px;
                        margin-left: 12px;
                    }

                    .class_num {
                        max-width:510px;
                        font-size:26px;
                        font-weight:300;
                        color:#666;
                        line-height:28px;
                    }

                    .copy_map_icon {
                        width:28px;
                        height:26px;
                        margin-left: 12px;
                    }

                    .card_year_icon {
                        width: 26px;
                        height: 26px;
                        margin-right: 18px;
                        position: relative;
                        top: -1px;
                    }

                    .card_time_icon {
                        width: 26px;
                        height: 26px;
                        margin-right: 16px;
                    }
                }

                .course_dot_line {
                    width:590px;
                    height: .5px;
                    background: #e3e3e3;
                    border-radius:10px;
                    transform: scale(1,.5);
                    margin: 32px 0;
                }

                .price_symbol_content {
                    margin-left: auto;
                }

                .price_symbol {
                    font-size: 24px;
                    line-height: 24px;
                    color: #FF870F;
                    margin-right: 6px;
                }

                .course_price {
                    font-size:48px;
                    font-weight:500;
                    color: #FF870F;
                    line-height:48px;
                }

                .more_teacher_content {
                    margin-right: 24px;
                    .teacher_icon {
                        width: 48px;
                        height: 48px;
                        border-radius: 30px;
                        margin-right: 24px;
                    }
                    .teacher_name {
                        font-size: 26px;
                        line-height: 26px;
                        font-weight:400;
                        color: #666666;
                    }
                }

                .teacher_group {
                    font-size: 24px;
                    font-weight: 400;
                    color: #999999;
                    line-height: 34px;
                    margin-top: 10px;
                }

                .select_icon {
                    position: absolute;
                    top: 40px;
                    right: 40px;
                    width: 40px;
                    height: 40px;
                    img {
                        display: block;
                        width: 100%;
                    }
                }
            }
        }
        .package_content_bottom {
            margin-bottom: 80px;
        }
    }
    .course_package_list_top {
        margin-top: 44px;
    }
    .course_content_hidden {
        max-height: 1100px;
        overflow: hidden;
    }
</style>
